import PurchaseIframe from "../../../Products/PurchaseIframe";
import { ProductFamilyIds } from "../../../Products/constants";
import PurchaseBar from "../../../Products/PurchaseBar";
import OpportunitiesTerms from "./OpportunitiesTerms";
import { MapLocationDotSolidV6 } from "@shared/v2/Icomoon";
import useOpportunitiesProduct from "./hooks/useOpportunitiesProduct";

const OpportunitiesPurchase = () => {
  const { loading, product } = useOpportunitiesProduct();
  return (
    <PurchaseIframe src="https://www.brivity.com/opportunities-in-app" title="Opportunities Add-On">
      {!loading && (
        <PurchaseBar
          completeModalProps={{
            Icon: MapLocationDotSolidV6,
            title: "Congratulations on unlocking Opportunities!",
            description: "Opportunities is now available for your team to use - click get started to begin.",
            url: "/opportunities",
          }}
          selectProduct={(products) => products.find((p) => p.id === product?.id)}
          getSubtitle={(product) =>
            `Add more transactions to your team’s production for only $${product?.details.unitPrice}. Cancel anytime.`
          }
          productFamilySlug={ProductFamilyIds.Opportunities}
          terms={<OpportunitiesTerms />}
          title="Prospect and convert without leaving your CRM"
        />
      )}
    </PurchaseIframe>
  );
};

export default OpportunitiesPurchase;
